




import { Vue, Component } from 'vue-property-decorator';
import { autoOpenApp } from '@/common/ts/common';
import { appShare, wxShareInfo } from '@/common/ts/common';
import { getRules } from '@/api/api';
@Component
export default class Rules extends Vue {
  rules: any = null;
  created() {
    getRules('2020project/2020homefurnishing').then((res) => {
      this.rules = res.data;
    });
    autoOpenApp();
    // 分享
    appShare({
      title: '红星美凯龙“守护者联盟”家居大牌强势集结，联合守护逆势破局',
      url: window.location.href,
      subtitle: '红星美凯龙“守护者联盟”家居大牌强势集结，联合守护逆势破局',
      classId: -1,
      id: -1,
      image:
        'https://image2.cqcb.com/d/file/az8kHQjqWwjwEFPq9cwoyiPWyAG93F4CP4QBvnCn.jpeg',
      type: 3,
    });
    wxShareInfo({
      title: '红星美凯龙“守护者联盟”家居大牌强势集结，联合守护逆势破局',
      subtitle: '红星美凯龙“守护者联盟”家居大牌强势集结，联合守护逆势破局',
      image:
        'https://image2.cqcb.com/d/file/az8kHQjqWwjwEFPq9cwoyiPWyAG93F4CP4QBvnCn.jpeg',
    });
  }
}
